export default {"src":"/_next/static/media/window-picture.875b0744.svg","height":1000,"width":1000};